import { BasicDomTarget, getTargetElement } from './dom-target';

/**
 * 计算H5原生滚动条滚动距离
 * @param target
 * @returns
 */
export const getScrollPosition = (target: BasicDomTarget) => {
  const targetElement = getTargetElement<Element | Document | Window>(target, document);
  let position = { left: 0, top: 0 };
  if (targetElement === document || targetElement === window) {
    if (document.scrollingElement) {
      position = {
        left: document.scrollingElement.scrollLeft,
        top: document.scrollingElement.scrollTop,
      };
    } else {
      // When in quirks mode, the scrollingElement attribute returns the HTML body element if it exists and is potentially scrollable, otherwise it returns null.
      // https://developer.mozilla.org/zh-CN/docs/Web/API/Document/scrollingElement
      // https://stackoverflow.com/questions/28633221/document-body-scrolltop-firefox-returns-0-only-js
      position = {
        top: Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop),
        left: Math.max(window.pageXOffset, document.documentElement.scrollLeft, document.body.scrollLeft),
      };
    }
  } else {
    position = {
      left: (targetElement as Element)?.scrollLeft || 0,
      top: (targetElement as Element)?.scrollTop || 0,
    };
  }
  return position;
};
